export { default as UserAddPage } from "./user-add-page";
export { default as UserEditPage } from "./user-edit-page";
import usersPage from "./users-page";
import withRedux from "./with-redux";

export const UsersPage = withRedux(usersPage);
